// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__7Spo3","headerLink":"styles_headerLink__40v6b","upperText":"styles_upperText__cB6kp","truncate":"styles_truncate__rvbJr"};